/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Link as LinkRaw, LinkProps } from 'react-router-dom';
import { generatePathOrReturnAbsoluteLink } from '../../../lib';

const Link = ({
    to,
    replace,
    className,
    onClick,
    children,
}: LinkProps): JSX.Element => {
    return (
        <LinkRaw
            to={generatePathOrReturnAbsoluteLink(to.toString())}
            onClick={onClick}
            className={className}
            replace={replace}>
            {' '}
            {children}{' '}
        </LinkRaw>
    );
};

export { Link };
